import { z } from 'zod';
import '@apexdesigner/schema-tools';
import {
  belongsTo,
  hasMany,
  options,
  references,
} from '@apexdesigner/schema-tools';

export const attendance = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    date: z.string().nullable().optional().presentAs('date').describe('Date'),

    attendanceType: options([
      { value: 'Present', name: 'Present' },
      { value: 'Absent', name: 'Absent' },
    ])
      .nullable()
      .optional()
      .describe('Attendance Type'),

    absenceType: options([
      { value: 'Excused', name: 'Excused' },
      { value: 'Unexcused', name: 'Unexcused' },
    ])
      .nullable()
      .optional()
      .describe('Absence Type'),

    isTemporaryAssignment: z
      .boolean()
      .nullable()
      .optional()
      .describe(
        'Is Temporary Assignment - Whether the tutor is a temporary stand-in',
      ),

    studentId: z.number().hidden().describe('Foreign key to Student'),

    termTutorId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to TermTutor'),

    timeId: z
      .number()
      .presentAs('reference')
      .describe('Foreign key to TermTime'),

    student: belongsTo('Student'),

    termTutor: references('TermTutor'),

    time: references('TermTime'),

    sessions: hasMany('Session'),
  })
  .describe(
    'A record that a student was present or absent for a term time on a given date.',
  )
  .as('Attendance');

export { attendance as attendanceSchema };
